import { useEffect, useState } from 'react';
import { Route, useHistory } from "react-router-dom";

import Header from "../components/header";

import HomePage from "./homePage";
import Reserve from "./reserve";
import ContactUs from "./contact-us";
import AboutUs from "./about-us";
import ImageGallery from "./Gallery";
import RefrandomPage from "./refrandom";
import Post from "./post";
import MBtiTest from './mbti';
import MBtiTestResult from './mbti/result';
import NewTestComponent from './NewTest';

import './routingStyles.scss';

const AllRoutes = () => {
  const history = useHistory();
  const [componentClass, setClass] = useState('hidden');

  useEffect(() => {
    setClass("visible")
    history.listen(route => {
      setClass("hidden")
      setTimeout(() => {
        setClass("visible")
      } , 250)
    })
  } , [0]);
  return (
    <>
      <Header />
      <div className="container-fluid mt-5">
        <div className={`row ${componentClass}`}>
          <div className="col-12">
            <Route path="/" component={HomePage} exact />
            <Route
              path="/refrandom/:paymentStatus/:price/:trackCode"
              component={RefrandomPage}
              exact
            />
            <Route path="/mbti" component={MBtiTest} exact/>
            <Route path="/mbti/result" component={MBtiTestResult} exact/>
            <Route path="/refrandom" component={RefrandomPage} exact />
            <Route path="/visit" component={Reserve} exact />
            <Route path="/about-us" component={AboutUs} exact />
            <Route path="/contact-us" component={ContactUs} exact />
            <Route path="/gallery" component={ImageGallery} exact />
            <Route path="/gallery/post" component={Post} exact />
            <Route
              path="/:paymentStatus/:price/:trackCode"
              component={HomePage}
              exact
            />
            <Route path={"/new_test"} component={NewTestComponent} exact={true} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AllRoutes;
